import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { usePlanCardContext } from '../../context';
import * as Styled from './styles';
import type { PlanDescriptionProps as Props } from './types';

export const PlanDescription = memo(({ className }: Props) => {
  const { isPaid } = usePlanCardContext();

  return (
    <Styled.Wrapper
      className={classnames('PlanDescription', className)}
      variant="body4"
      mb={1}
      color={isPaid ? 'common.white' : 'grey.500'}
      fontWeight={400}
    >
      {isPaid
        ? 'Pay for what you need. Choose a credit package that fits your current needs.'
        : 'Test the worth of our platform on your business with our free trial.'}
    </Styled.Wrapper>
  );
});

PlanDescription.displayName = 'PlanDescription';
